import React from "react";

/**
 * Default illustration for Coming Soon pages (Trocanet orange brand).
 */
export default function ComingSoonIllustration({ className = "" }) {
  return (
    <svg
      className={`coming-soon-illustration ${className}`.trim()}
      viewBox="0 0 420 320"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Coming soon illustration"
    >
      <defs>
        <linearGradient id="csGlow" x1="60" y1="40" x2="360" y2="280" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFF4EB" />
          <stop offset="1" stopColor="#FFE8D6" />
        </linearGradient>
        <linearGradient id="csOrb" x1="210" y1="70" x2="210" y2="250" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF8A3D" />
          <stop offset="1" stopColor="#FF6A00" />
        </linearGradient>
      </defs>

      <circle cx="210" cy="160" r="118" fill="url(#csGlow)" />
      <circle cx="210" cy="160" r="88" fill="#fff" stroke="#FFE0C7" strokeWidth="2" />

      {/* Soft orbit dots */}
      <circle cx="95" cy="110" r="6" fill="#FFB27A" opacity="0.7" />
      <circle cx="330" cy="95" r="8" fill="#FF6A00" opacity="0.35" />
      <circle cx="340" cy="210" r="5" fill="#FFAE1F" opacity="0.8" />
      <circle cx="85" cy="220" r="7" fill="#FF8A3D" opacity="0.45" />

      {/* Rocket body */}
      <path
        d="M210 78c28 22 42 58 42 98 0 18-4 34-12 48l-30 46-30-46c-8-14-12-30-12-48 0-40 14-76 42-98Z"
        fill="url(#csOrb)"
      />
      <path
        d="M210 102c16 16 24 42 24 70 0 14-3 26-8 36l-16 24-16-24c-5-10-8-22-8-36 0-28 8-54 24-70Z"
        fill="#FF8F45"
      />
      <circle cx="210" cy="158" r="18" fill="#fff" opacity="0.95" />
      <circle cx="210" cy="158" r="10" fill="#0B74DE" opacity="0.85" />

      {/* Fins */}
      <path d="M168 198c-18 6-32 20-38 38 22-2 40-12 52-28l-14-10Z" fill="#E85F00" />
      <path d="M252 198c18 6 32 20 38 38-22-2-40-12-52-28l14-10Z" fill="#E85F00" />

      {/* Flame */}
      <path d="M198 270c4 14 8 22 12 30 4-8 8-16 12-30-4-6-8-10-12-10s-8 4-12 10Z" fill="#FFAE1F" />
      <path d="M204 274c2 10 4 16 6 22 2-6 4-12 6-22-2-4-4-6-6-6s-4 2-6 6Z" fill="#FFF4EB" />

      {/* Soft decorative capsule */}
      <rect x="155" y="48" width="110" height="16" rx="8" fill="#111827" opacity="0.08" />
      <circle cx="175" cy="56" r="3" fill="#FF6A00" opacity="0.7" />
      <rect x="186" y="53" width="62" height="6" rx="3" fill="#FF6A00" opacity="0.35" />
    </svg>
  );
}
